import { SelectControl, Spinner } from "@wordpress/components";

const TaxonomyTermsSelect = (props) => {
	const { terms, selectTerm, selectedTerm, label } = props;

	if (!terms) {
		return (
			<div>
				<Spinner />
				{__("Chargement des catégories", "a3web-blocks")}
			</div>
		);
	}

	return (
		<SelectControl
			label={label ? label : "Taxonomy"}
			value={selectedTerm}
			options={terms.map((item) => ({ value: item.id, label: item.name }))}
			onChange={(category) => {
				selectTerm(parseInt(category));
			}}
		></SelectControl>
	);
};

export { TaxonomyTermsSelect };
